// import { Button } from 'baseui/button';
import { DataList } from 'commons-ui';
import React from 'react';
import { useStyletron } from 'styletron-react';

import serviceConfig from './serviceConfig';
import useZookeeperActions from '../../utils/useZookeeperActions';
import { makeServicesActionList } from '../../actions/list';
import { makeActionHandler } from '../../actions/handler';
import useService from '../../utils/useService';

const Services: React.FC<{}> = () => {
	const { getActionHandler, getActionList } = useZookeeperActions(makeActionHandler, makeServicesActionList);

	const { getZkServices } = useService();
	const [css] = useStyletron();
	const actions = getActionList();
	return (
		<div
			className={css({
				padding: '20px'
			})}>
			<div
				className={css({
					fontWeight: 'bold',
					fontSize: '32'
				})}>
				List of Services
			</div>
			<div>
				<DataList
					fetchData={getZkServices}
					columnConfigs={serviceConfig}
					getActionHandler={getActionHandler}
					actions={actions}
					rowHeight={100}
					entity='Services'
					initialSortDirection='ASC'
					initialSortIndex={1}
				/>
			</div>
		</div>
	);
};

export default Services;
